import { render, staticRenderFns } from "./advantage.vue?vue&type=template&id=7b5878da&scoped=true&"
var script = {}
import style0 from "./advantage.vue?vue&type=style&index=0&id=7b5878da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5878da",
  null
  
)

export default component.exports